import NotificationImportantIcon from '@mui/icons-material/NotificationImportant'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Chip, IconButton } from '@mui/material'
export const NotificationIconButton = ({
  numUnreadNotifications,
  notificationAnchorEl,
  setNotificationAnchorEl,
  refetchNotifications
}: {
  numUnreadNotifications: number | undefined
  notificationAnchorEl: HTMLElement | null
  setNotificationAnchorEl: (
    value: React.SetStateAction<HTMLElement | null>
  ) => void
  refetchNotifications: () => void
}) => {
  return (
    <IconButton
      onClick={(event: React.MouseEvent<HTMLElement>) => {
        refetchNotifications()
        if (notificationAnchorEl) {
          setNotificationAnchorEl(null)
        } else {
          setNotificationAnchorEl(event.currentTarget)
        }
      }}>
      {!numUnreadNotifications ? (
        <NotificationsIcon sx={{ color: 'white' }} />
      ) : (
        <NotificationImportantIcon sx={{ color: 'white' }} />
      )}
    </IconButton>
  )
}

export const NotificationChip = ({
  numUnreadNotifications,
  notificationAnchorEl,
  setNotificationAnchorEl,
  refetchNotifications
}: {
  numUnreadNotifications: number | undefined
  notificationAnchorEl: HTMLElement | null
  setNotificationAnchorEl: (
    value: React.SetStateAction<HTMLElement | null>
  ) => void
  refetchNotifications: () => void
}) => {
  return !numUnreadNotifications ? (
    <Chip
      color="info"
      icon={<NotificationsIcon />}
      onClick={(event: React.MouseEvent<HTMLElement>) => {
        refetchNotifications()
        if (notificationAnchorEl) {
          setNotificationAnchorEl(null)
        } else {
          setNotificationAnchorEl(event.currentTarget)
        }
      }}
      label={numUnreadNotifications || 0}
    />
  ) : (
    <Chip
      color="error"
      icon={<NotificationsIcon />}
      onClick={(event: React.MouseEvent<HTMLElement>) => {
        refetchNotifications()
        if (notificationAnchorEl) {
          setNotificationAnchorEl(null)
        } else {
          setNotificationAnchorEl(event.currentTarget)
        }
      }}
      label={numUnreadNotifications}
    />
  )
}
